import React, { useState } from 'react';
import css from '../../../../styles/modules/PaymentSummary/paymentdetails.module.css';
import { AiOutlineDownload } from 'react-icons/ai';
import { BsShareFill } from 'react-icons/bs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ShareModal from './ShareModal';
import { ToastContainer, toast } from 'react-toastify';

export default function CardHeader({
  transfer,
  cardContainerRef,
  paymentId,
  attachments,
}) {
  const [modalOpen, setModalOpen] = useState(false);

  const exportToPDF = async () => {
    const input = cardContainerRef.current;

    const canvas = await html2canvas(input, {
      onclone: (clonedDocument) => {
        const brandLogo = clonedDocument.getElementById('brand-logo');
        if (brandLogo) brandLogo.style.display = 'block';
        const downloadIcon = clonedDocument.querySelector(
          `.${css.downloadIcon}`,
        );
        const shareIcon = clonedDocument.querySelector(`.${css.shareIcon}`);
        const detailsCaret = clonedDocument.getElementById('Details_Caret');
        const financialsCaret =
          clonedDocument.getElementById('Financials_Caret');

        if (downloadIcon) downloadIcon.style.display = 'none';
        if (shareIcon) shareIcon.style.display = 'none';

        if (detailsCaret) detailsCaret.style.transform = 'rotate(0deg)';
        if (financialsCaret) financialsCaret.style.transform = 'rotate(0deg)';
      },
    });

    const pdfWidthMm = 210; // width of A4 in mm
    const pdfHeightMm = 295; // height of A4 in mm

    // Calculate the scale factors for both dimensions
    const widthScale = pdfWidthMm / (canvas.width * 1.15);
    const heightScale = pdfHeightMm / (canvas.height * 1.15);

    // Use the smallest scale factor to ensure content fits without exceeding the A4 dimensions
    const scaleFactor = Math.min(widthScale, heightScale);

    const imgWidth = canvas.width * scaleFactor;
    const imgHeight = canvas.height * scaleFactor;

    const doc = new jsPDF('p', 'mm');
    doc.addImage(
      canvas.toDataURL('image/png'),
      'PNG',
      0,
      0,
      imgWidth,
      imgHeight,
    );
    doc.save('download.pdf');
  };

  return (
    <div className={css.cardHeaderWrapper}>
      <ToastContainer />
      <ShareModal
        toast={toast}
        setModalOpen={setModalOpen}
        transfer={transfer}
        open={modalOpen}
      />
      <div className={css.paymentIdDescriptor}>
        <p className={css.paymentIdHeadline}>{`Payment ID: `}</p>
        <p className={css.paymentIdData}>{paymentId ? `${paymentId}` : null}</p>
      </div>
      <AiOutlineDownload onClick={exportToPDF} className={css.downloadIcon} />
      <BsShareFill
        onClick={() => setModalOpen(true)}
        className={css.shareIcon}
      />
    </div>
  );
}
